// const serverUrl = "http://localhost:8800/api";
const serverUrl = "https://sportify-4u9r.onrender.com/api";
export const chatUrl = "https://sportify-chat.onrender.com";
// export const chatUrl = "ws://localhost:8900";
export default serverUrl;
